/** Central file for shared FUOTA-related enums and types */

export enum CampaignStatus {
    NotStarted = "Not started",
    InProgress = "In progress",
    Paused = "Paused",
    Completed = "Completed",
    CompletedWithErrors = "Completed with errors",
    Cancelled = "Cancelled",
    Wrapping = "Wrapping",
    ERROR = "ERROR",
}

export enum CampaignStage {
    CreatingSessions = "Creating sessions",
    StartDateInPast = "Start date is in the past",
    ErrorCreatingSessions = "Error creating sessions",
    ErrorDuringStart = "Error during start",
    Cancelled = "Cancelled",
    CancellationInProgress = "Cancellation in progress",
    DeletingSessions = "Deleting sessions",
    UnicastProgramming = "Unicast programming phase",
    AbortedDelivery = "Aborted delivery of FW",
    Completed = "Update campaign completed"
}

export enum SessionStatus {
    NotStarted = "Not started",
    InProgress = "In progress",
    Paused = "Paused",
    Completed = "Completed",
    CompletedWithErrors = "Completed with errors",
    ERROR = "ERROR",
}

export enum SessionStage {
    UnicastProgramming = "Unicast programming phase",
    AdditionalUnicast = "Additional unicast phase",
    BroadcastingFragments = "Broadcasting FW fragments",
    UnicastingFragments = "Unicasting FW fragments",
    InitializationError = "Initialization Error",
    SomeDevicesFailed = "Some devices failed",
    AllDevicesFailed = "All devices failed",
    AllDevicesUpdated = "All devices updated",
    DeletingSessions = "Deleting sessions",
}
